import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import SubHeader from '../../../../components/SubHeader';
import Search from '../../../../components/Search';
import Button from '../../../../components/Button';
import Modal from '../../../../components/Modal';

import ScheduleTable from './components/ScheduleTable';
import ScheduleDetail from './components/ScheduleDetail';

// Thunks
import { getScheduleList } from '../../../../redux/scheduling';

// css
import './styles.css';

class ScheduleList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scheduleDetailsIsVisible: false,
      cancelConfirmationIsVisible: false,
      cancelConfirmationScheduleId: 0,
      activeSchedule: {},
    };
  }

  _onTableItemClick = (data) => {
    this.setState({
      scheduleDetailsIsVisible: true,
      activeSchedule: data,
    });
  }

  _onDismiss = () => {
    this.setState({
      scheduleDetailsIsVisible: false,
    });
  }

  _openCancelConfirmationModal = (scheduleId) => {
    this.setState({
      cancelConfirmationScheduleId: scheduleId,
      cancelConfirmationIsVisible: true,
    });
  }

  _closeCancelConfirmationModal = () => {
    this.setState({
      cancelConfirmationScheduleId: 0,
      cancelConfirmationIsVisible: false,
    });
  }

  _onSearch = (searchVal) => {
    this.props.dispatch(getScheduleList(1, 10, searchVal));
  }

  render() {
    return (
      <div className="ScheduleList">
        <SubHeader
          title="Agendamentos"
          renderSide={() => (
            <div className="ScheduleList__header-search-container">
              <Button
                className="ScheduleList__header-new-schedule-btn"
                skin="primary"
                text="+ Novo Agendamento"
                onClick={() => this.props.history.push(`${this.props.match.url}/novo`)}
              />
              <Search
                className="ScheduleList__header-search-field"
                placeholder="Buscar por ID"
                onSearch={this._onSearch}
              />
            </div>
          )}
        />

        <div className="ScheduleList__content">
          <ScheduleTable
            scheduleList={this.props.scheduleList}
            onTableItemClick={(data) => { this._onTableItemClick(data); }}
          />

          {
            this.state.scheduleDetailsIsVisible &&
            <ScheduleDetail
              openCancelConfirmationModal={this._openCancelConfirmationModal}
              onDismiss={() => { this._onDismiss(); }}
              data={this.state.activeSchedule}
            />
          }

          {
            this.state.cancelConfirmationIsVisible &&
            <Modal
              title="Agendamento cancelado com sucesso."
              size="small"
            >
              O agendamento <strong>{this.state.cancelConfirmationScheduleId}</strong> foi cancelado com sucesso!

              <div className="ScheduleList__cancel-schedule-modal-footer">
                <Button
                  skin="primary"
                  text="Ok"
                  onClick={this._closeCancelConfirmationModal}
                />
              </div>
            </Modal>
          }
        </div>
      </div>
    );
  }
}

export default connect(null)(ScheduleList);